import { FC } from 'react';
import { Modal, ModalOverlay } from '@chakra-ui/react';
import { EditHookReturnType } from '../../types';
import { REGISTRATION_STEP } from '../../../../../constants/registrationStep';
import { TaskRegistrationInputModalView } from './TaskRegistrationInputModalView';
import { TaskRegistrationConfirmModalView } from './TaskRegistrationConfirmModalView';
import { TaskRegistrationResultModalView } from './TaskRegistrationResultModalView';

type Props = EditHookReturnType;

export const TaskRegistrationModalView: FC<Props> = ({
  isOpenModal,
  onCloseModal,
  onCloseModalWhenCompleted,
  currentModalStep,
  form,
  values,
  onConfirm,
  onGoBack,
  onSubmit,
  onOpenModalDelete,
  mode,
  control,
  releaseEnvironments,
  targetGroupList,
  handleChangeCondition,
  shouldShowCustomerList,
  selectedCustomers,
  handleChangeSelectTargetGroupInput,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="4xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
  >
    <ModalOverlay />
    {currentModalStep === REGISTRATION_STEP.INPUT && (
      <TaskRegistrationInputModalView
        mode={mode}
        {...form}
        control={control}
        handleConfirm={onConfirm}
        onOpenModalDelete={onOpenModalDelete}
        releaseEnvironments={releaseEnvironments}
        targetGroupList={targetGroupList}
        handleChangeCondition={handleChangeCondition}
        shouldShowCustomerList={shouldShowCustomerList}
        handleChangeSelectTargetGroupInput={handleChangeSelectTargetGroupInput}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.CONFIRMATION && (
      <TaskRegistrationConfirmModalView
        mode={mode}
        values={values}
        handleBack={onGoBack}
        handleSubmit={onSubmit}
        releaseEnvironments={releaseEnvironments}
        targetGroupList={targetGroupList}
        shouldShowCustomerList={shouldShowCustomerList}
        selectedCustomers={selectedCustomers}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.RESULT && (
      <TaskRegistrationResultModalView
        mode={mode}
        values={values}
        handleClose={onCloseModalWhenCompleted}
        releaseEnvironments={releaseEnvironments}
        targetGroupList={targetGroupList}
        shouldShowCustomerList={shouldShowCustomerList}
        selectedCustomers={selectedCustomers}
      />
    )}
  </Modal>
);
